import { isNullOrUndefined } from '../../util/helpers';


export class Wind {
  /**
   * Wind direction (in degrees), or null for calm or variable winds. Note that north is expressed as 360. The value
   * 0 is used to encode variable wind direction.
   */
  direction: number;

  /**
   * Wind speed (in knots), returned as a formatted HTML string (possibly with warn/alert CSS class)
   */
  speed: string;

  /**
   * Gust factor, returned as a formatted HTML string (possibly with warn/alert CSS class)
   */
  gust: string;

  /**
   * Returns true if the winds are calm
   * @returns {boolean}
   */
  get calm(): boolean {
    return !this.direction && (!this.speed || this.speed === '0') && (!this.gust || this.gust === '0');
  }

  /**
   * Returns true if the wind direction is variable
   * @returns {boolean}
   */
  get vrb(): boolean {
    return !this.calm && this.direction === 0;
  }

  /**
   * Parse wind data as returned by API into an instance of the Wind type
   * @param direction
   * @param speed
   * @param gust
   * @returns {Wind}
   */
  static parse(direction: number, speed: string, gust: string): Wind {
    if ([direction, speed, gust].every(isNullOrUndefined)) {
      return null;
    }
    return Object.assign(new Wind(), {
      direction: direction,
      speed: speed,
      gust: gust
    });
  }
}
